<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="getHeaderScreenJson.title.createModeIsEditMode"
        :baseView="baseView"
        :primaryLabel="'Create Sales Order V3'"
        :secondaryLabel="undefined"
      />
    </template>
    <gc-header-form
      :headerOptions="getHeaderScreenJson"
      :data="loaded ? model : {}"
      :saveTransaction="saveTransaction"
      :backButtonRoute="backButtonRoute"
      ref="gc-header-form-component"
      :getHeaderToolbar="undefined"
      :setLoading="showLoading"
    ></gc-header-form>
    <div>
      <dx-data-grid
        :data-source="productEntryLocalItems"
        :columns="getProductEntryColumns2"
        :height="getGridHeight"
        :column-chooser="{ enabled: false }"
        :ref="'dx-data-grid-comp'"
        :key-expr="'ID'"
        :repaint-changes-only="true"
        :show-borders="true"
        :on-row-prepared="onRowPrepared"
        :two-way-binding-enabled="false"
        @editor-preparing="onEditorPreparing"
        :focusedRowEnabled="true"
      >
        <!-- <DxPaging :enabled="false" /> -->
        <DxEditing
          :allow-updating="true"
          mode="cell"
          :new-row-position="'last'"
        />

        <DxKeyboardNavigation
          :edit-on-key-press="true"
          :enter-key-action="'startEdit'"
          :enter-key-direction="'none'"
          :enabled="true"
        />

        <DxSummary>
          <DxTotalItem
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'SalesUMNetFXPrice'"
            display-format="{0}"
            :show-in-column="'SalesUMNetFXPrice'"
            column="SalesUMNetFXPrice"
          />
          <DxTotalItem
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'TaxFXLineTotal'"
            display-format="{0}"
            :show-in-column="'TaxFXLineTotal'"
            column="TaxFXLineTotal"
          />

          <DxTotalItem
            column="TaxableFXLineTotal"
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'TaxableFXLineTotal'"
            display-format="{0}"
            :show-in-column="'TaxableFXLineTotal'"
          />
        </DxSummary>
      </dx-data-grid>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { getFactorByCode } from "../../_store/helpers";
import { ProductService } from "../../_services/api/products/product.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { FeatureStorage } from "../../_services/storage";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { SalesOrderV3Service } from "../../_services/api/sales/sales-order-v3.service";
import salesFormulas from "../../_helpers/formulas/sales-formulas";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { SalesOrderNoteService } from "../../_services/api/sales/sales-order-note.service";
import { mapGetters } from "vuex";

import ArrayStore from "devextreme/data/array_store";

const {
  // calculateGrossProfitPcnt,
  // calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateSalesUMPriceFromSalesUMFXPrice,
  calculateCalculatedDiscPcnt,
  // calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = salesFormulas;

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", ...arguments);
}

let productEntryBase = {
  ProductCode: "",
  ID: 1,

  IsBatchProduct: "No",
  BranchCode: undefined,
  BranchDescription: undefined,
  UnitOfMeasureCode: undefined,
  Onhand: undefined,
  AddDiscPriceGroupCode: undefined,
  AddDiscPricingMethod: undefined,
  AddDiscPricingMethodValue: undefined,
  AddDiscSalesUMPrice: undefined,
  AddDiscStockUMPrice: undefined,
  CalculatedDiscPcnt: undefined,
  Code: undefined,
  DiscFXLineTotal: undefined,
  DiscLineTotal: undefined,
  DiscPcnt: 0,
  ExTaxUnitCost: undefined,
  FXLineTotal: undefined,
  IsCopyLine: false,
  IsNewLine: true,
  IsPrimeCostItem: false,
  ItemCode: undefined,
  ItemType: undefined,
  LineNo: 0,
  LineTotal: 0,
  NetFXLineTotal: 0,
  NetLineTotal: 0,
  PriceGroupCode: null,
  PriceGroupSalesUMPrice: 0,
  PriceGroupStockUMPrice: 0,
  PricingMethod: null,
  PricingMethodValue: 0,
  ProductDescription: undefined,
  SalesTaxPcnt: 0,
  SalesUM: undefined,
  SalesUMConversion: 0,
  SalesUMCost: 0,
  SalesUMFXPrice: 0,
  SalesUMIsVariable: false,
  SalesUMManufacturedCost: 0,
  SalesUMNetFXPrice: 0,
  SalesUMNetPrice: 0,
  SalesUMPrice: 0,
  SalesUMPromotionNetPrice: 0,
  SalesUMQty: 0,
  SalesUMStandardCost: 0,
  SalesUMStandardPrice: 0,
  StockUM: undefined,
  StockUMFXPrice: 0,
  StockUMManufacturedCost: 0,
  StockUMNetFXPrice: 0,
  StockUMNetPrice: 0,
  StockUMPrice: 0,
  StockUMQty: 0,
  StockUMStandardCost: 0,
  StockUMStandardPrice: 0,
  TaxCode: undefined,
  TaxFXLineTotal: 0,
  TaxLineTotal: 0,
  TaxableFXLineTotal: 0,
  TaxableLineTotal: 0,
  WetFXLineTotal: 0,
  WetLineTotal: 0,
  WetPcnt: 0,
  validCode: undefined,
};
let deliveryAddressDataSourceItems = [];

export default {
  mixins: [RouteMixin, FormMixin],
  components: {},
  data() {
    return {
      loaded: false,
      setLoading: false,
      ui: {
        DateAdjustedMin: null,
        DateAdjustedMax: null,
      },

      factor368ExchangeRateFieldEditable: undefined,

      model: {
        CompanyCurrency: undefined,
        Status: "N",
        CustomStatus: undefined,
        FriendlyStatus: undefined,
        Code: null,

        CustomerCode: null,
        DateIn: new Date(),
        RequiredByDate: null,
        ShipDate: null,
        OrderNo: null,

        DeliveryAddressCompanyName: null,
        DeliveryAddressCountry: null,
        DeliveryAddressPostcode: null,
        DeliveryAddressState: null,
        DeliveryAddressStreetLine1: null,
        DeliveryAddressStreetLine2: null,
        DeliveryAddressSuburb: null,
        CustomerDeliveryAddressLineNo: undefined,

        ConsignmentNo: "",
        CurrencyCode: undefined,
        ExchangeRate: 1,

        BranchCode: null,
        DivisionCode: null,
        SalesOrderTypeCode: null,
        SalesRepresentativeCode: null,

        SalesOrderDetails: [],

        DateChanged: null,
        DateCreated: null,
        ChangedBy: null,
        CreatedBy: null,
        Notes: [],
      },

      productDataSourceItems: [],
      productEntryLocalItems: new ArrayStore({
        key: "ID",
        data: [],
      }),

      salesUMsLocalData: [],
      changes: [],
      editRowKey: null,
    };
  },

  async created() {},
  async mounted() {
    this.showLoading(true);
    this.initialized();
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
  },

  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),

    getGridHeight() {
      if (this.headerFormHeight) return this.gridHeight - this.headerFormHeight;
      else return this.gridHeight;
    },
    backButtonRoute() {
      return "/sales-order";
    },
    getScreenJson() {
      var screenJson = {
        title: "Sales Order",
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerFormVisible: true,
        deliveryAddressItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "DeliveryAddressCompanyName",
                editorType: "dxTextBox",
                label: {
                  text: "Name",
                },
                editorOptions: {
                  maxLength: "100",
                  readOnly: true,
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine1",
                dataField: "DeliveryAddressStreetLine1",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine2",
                dataField: "DeliveryAddressStreetLine2",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressSuburb",
                dataField: "DeliveryAddressSuburb",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressState",
                dataField: "DeliveryAddressState",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressPostcode",
                dataField: "DeliveryAddressPostcode",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressCountry",
                dataField: "DeliveryAddressCountry",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
            ],
          },
        ],
        headerToolbar: {
          audit: this.baseView.mode == "review",
          status: true,
          // notes: true,
          // notesItems: ["Order Comments", "Order Notes"],
          save:
            (this.baseView.mode != "edit" &&
              this.model.Status != "C" &&
              this.model.Status != "X") ||
            (this.baseView.mode == "edit" && this.model.Status != "C"),
          editURL: "/sales-order-v3",
          saveOptions: {
            items: this.baseView.id
              ? [
                  { text: "Draft", id: "D" },
                  { text: "Commit", id: "A", default: true },
                  { text: "Cancel", id: "X" },
                ]
              : [
                  { text: "Draft", id: "D" },
                  { text: "Commit", id: "A", default: true },
                ],
            keyExpr: "id",
            displayExpr: "text",
            dropDownOptions: {
              width: "150px",
            },
            saveKey: "NextStatus",
          },
          saveCallback: this.saveSalesOrder,
          screenName: "Sales Orders - All",
          pdf: this.baseView.mode == "review",

          toolbarFormItems: [
            {
              screenField: "Customer",
              dataField: "CustomerCode",
              cssClass: "toolbar-customer-label",
              editorOptions: {
                dropDownOptions: {
                  minWidth: 300,
                },
                width: 300,
                placeholder: "Customer Name",
                onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                showClearButton: true,
                onItemClick: this.onCustomerCodeItemClicked.bind(this),
              },
              label: {
                text: "Customer",
                visible: false,
              },
              required: true,
            },
          ],
          formContentReady: this.toolBarFormContentReady,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // // disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
              ],
            },
          ],
          customStatus: {
            enabled: true,
            key: "CustomStatus",
          },
          orderComments: {
            dataField: "SalesOrderTypeCode",
            endpoint: "SalesOrderType",
            toMatch: [
              "UserComment1",
              "UserComment2",
              "UserComment3",
              "UserComment4",
              "UserComment5",
              "UserComment6",
              "UserComment7",
              "UserComment8",
              "UserComment9",
              "UserComment10",
              "UserComment11",
              "UserComment12",
              "UserComment13",
              "UserComment14",
              "UserComment15",
              "UserComment16",
              "UserComment17",
              "UserComment18",
              "UserComment19",
              "UserComment20",
            ],
          },
          commentItems: [
            {
              itemType: "group",
              caption: "",
              items: [],
            },
          ],
        },
        title: {
          // Credit # [CreditNote] for Invoice # [InvoiceNumber]
          createModeIsEditMode: true,
          primary: {
            primary: {
              dataField: undefined,
              text:
                this.baseView.mode == "create"
                  ? "Create Sales Order"
                  : "Sales Order # " + this.baseView.id,
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          secondary: {
            dataField:
              this.baseView.mode == "create" ? undefined : "CustomerName",
            text: undefined,
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "DateIn",
                    label: {
                      text: "Date In",
                    },
                    dataField: "DateIn",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.onDateInValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "RequiredDate",
                    label: {
                      text: "Reqd Date",
                    },
                    dataField: "RequiredByDate",
                    required: true,
                    editorOptions: {
                      onValueChanged:
                        this.onRequiredByDateValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "ShipDate",
                    label: {
                      text: "Ship Date",
                    },
                    dataField: "ShipDate",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.onShipDateValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "CustPO",
                    dataField: "OrderNo",
                    editorOptions: {
                      onValueChanged: this.onOrderNoChanged.bind(this),
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "DeliverTo",
                    dataField: "DeliveryAddressCompanyName",
                    ref: "DeliveryAddressCompanyName",
                    required: true,
                    editorOptions: {
                      onItemClick: this.onDeliveryAddressChanged.bind(this),
                      // allowUpdate: true,
                    },
                    dataSourceConfig: {
                      // ingnore: true,
                      data: deliveryAddressDataSourceItems,
                    },
                    visible: this.baseView.mode != "review",
                  },

                  {
                    screenField: "DeliverTo",
                    dataField: "DeliveryAddressCompanyName",
                    ref: "DeliveryAddressCompanyName",
                    required: true,
                    visible: this.baseView.mode == "review",
                  },
                  {
                    screenField: "DeliveryCompanyView",
                    editAddress: this.baseView.mode != "review" ? true : false,
                  },
                  {
                    screenField: "ConNote",
                    dataField: "ConsignmentNo",
                  },
                  {
                    screenField: "CurrencyCode",
                    dataField: "CurrencyCode",
                    editorOptions: {
                      readOnly: true,
                    },
                  },
                  {
                    screenField: "ExchangeRate",
                    dataField: "ExchangeRate",
                    editorOptions: {
                      // TODO: Check the ReadOnly Logic
                      readOnly: true,
                      onValueChanged: this.onExchangeValueChanged,
                    },
                    required: true,
                    validationRules: [
                      {
                        type: "custom",

                        validationCallback: ({ value, rule }) => {
                          rule.message = `Exchange rate Cannot be 0 or Negative`;
                          return value > 0;
                        },
                      },
                    ],
                  },
                ],
              },

              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "Branch",
                    label: {
                      text: "Branch",
                    },
                    dataField: "BranchCode",
                    required: true,
                    editorOptions: {
                      onValueChanged: async (e) => {
                        await this.getSalesUMs(e.value);
                        this.triggerPriceChange(e);
                      },
                    },
                  },
                  {
                    screenField: "Division",
                    label: {
                      text: "Division",
                    },
                    dataField: "DivisionCode",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.triggerPriceChange.bind(this),
                    },
                  },
                  {
                    // dataField: "SalesOrderTypeDescription",
                    screenField: "OrderType",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.triggerPriceChange.bind(this),
                    },
                  },
                  {
                    screenField: "OrderRep",
                    dataField: "SalesRepresentativeCode",
                    label: {
                      text: "Sales Rep",
                    },
                    required: true,
                    // defaultValue: this.getDefaultSalesRep,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    getProductEntryColumns() {
      return [
        {
          // screenField: "Comments",
          label: "Product",
          dataField: "ProductCode",
          showEditorAlways: true,
          allowSearch: false,
          allowSorting: false,
          allowEditing: true,
          minWidth: 250,
          // editCellTemplate: "EditableText",
          // valueChangeCallBack: this.onProductCodeChange,
          // onKeyDown: this.onKeyDownCallBack,
          visible: this.dataViewType != "review",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            // onValueChanged: this.onProductCodeChange,
            // onFocusIn: (e) => {
            //   e.event.target.select();
            // },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "Comments",
          label: "Description",
          dataField: "ProductDescription",
          showEditorAlways: false,
          allowSearch: true,
          allowSorting: false,
          allowEditing: false,
          minWidth: 250,
          visible: this.dataViewType != "review",
        },
        {
          screenField: "Item",
          showEditorAlways: false,
          allowEditing: false,
          label: "Product",
          visible: this.dataViewType == "review",
        },
        {
          screenField: "SalesUMQty",
          dataField: "SalesUMQty",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          showEditorAlways: this.dataViewType != "review",
          allowSorting: false,
          allowEditing: this.dataViewType != "review",
          allowSearch: false,
          allowFiltering: false,
          // minmax: { min: 0, max: 999999999.99 },
          dataType: "number",
          editorOptions: {
            min: 0,
            max: 999999999.99,
            onValueChanged: (e, lineData) => {
              lineData.data.SalesUMQty = e.value;
              if (lineData.data.Code) this.getItemPriceDetails(lineData);
            },
            onKeyDown: this.onKeyDownCallBack,
            mode: "number",
          },
          // onKeyDown: this.onKeyDownCallBack,
        },
        {
          screenField: "SalesUM",
          dataField: "SalesUM",
          showEditorAlways: this.dataViewType != "review",
          allowEditing: this.dataViewType != "review",
          allowSorting: false,
          width: 80,
          minWidth: 80,
          allowSearch: false,
          dataType: "object",
          cssClass: "edit-cell-select-field",
          allowUpdate: true,
          lookup:
            this.dataViewType != "review"
              ? {
                  allowClearing: false,
                  dataSource: (data) => {
                    var dataSource = [];

                    if (data && data.data && data.data.Code) {
                      this.salesUMsLocalData.forEach((element) => {
                        if (element.ItemCode == data.data.Code)
                          dataSource.push(element);
                      });

                      data.data.SLUMLength = dataSource.length;
                    }
                    return dataSource;
                  },
                  displayExpr: "SalesUM",
                  valueExpr: "SalesUM",
                }
              : undefined,
          editorOptions: {
            dropDownOptions: {
              minWidth: 100,
            },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "SalesUMFXPrice",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          showEditorAlways: this.dataViewType != "review",
          // type: "Decimal"
          gridLabel: `Price (${this.model.CurrencyCode})`,
          allowSorting: false,
          allowSearch: false,
          allowEditing: this.dataViewType != "review",
          width: 150,
          minWidth: 150,
          // onKeyDown: this.onKeyDownCallBack,
          editorOptions: {
            onValueChanged: (e, lineData) => {
              lineData.data.SalesUMFXPrice = e.value;
              // this.onSalesUMFXPriceChanged(e, lineData);
            },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "DiscountPercent",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          showEditorAlways: this.dataViewType != "review",
          allowEditing: this.dataViewType != "review",
          allowSorting: false,
          allowSearch: false,
          width: 150,
          minWidth: 150,
          // onKeyDown: this.onKeyDownCallBack,
          editorOptions: {
            onValueChanged: (e, lineData) => {
              lineData.data.DiscPcnt = e.value;
              // this.onSoDetailsDiscountChanged(e, lineData);
            },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "SalesUMNetFXPrice",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          allowEditing: false,
          // type: "Decimal"
          gridLabel: `Net (${this.model.CurrencyCode})`,
          allowSorting: false,
          allowSearch: false,
          width: 150,
          minWidth: 150,
        },
        {
          screenField: "TaxableFXLineTotal",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          allowEditing: false,
          // type: "Decimal"
          gridLabel: `Total (${this.model.CurrencyCode})`,
          allowSorting: false,
          allowSearch: false,
          width: 150,
          minWidth: 150,
        },
        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
        },
        {
          dataField: "ActionCopy",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionCopy",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
          allowSearch: false,
          allowFiltering: false,
        },
        {
          dataField: "ActionAddNew",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionAddNew",
          visible:
            this.baseView.mode != "review" &&
            this.dataViewType == "product-entry",
          cssClass: "class-custom-btn",
        },
      ];
    },
    getProductEntryColumns2() {
      return [
        {
          caption: "Product",
          dataField: "ProductCode",
          showEditorAlways: this.baseView.mode != "review",
          allowSearch: false,
          allowSorting: false,
          allowEditing: this.baseView.mode != "review",
          minWidth: 250,
          visible: this.dataViewType != "review",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: async (e) => {
              if (e.event.key == "Enter") {
                setTimeout(() => {
                  // var dataGrid = this.$refs["dx-data-grid-comp"].instance;

                  var maxID = Math.max(
                    ...this.productEntryLocalItems._array.map((e) => e.ID)
                  );
                  let dataObj = Object.assign(
                    { IsCopyLine: false, IsNewLine: true },
                    productEntryBase
                  );
                  dataObj.ID = ++maxID;

                  // this.productEntryLocalItems.push([
                  //   { type: "insert", data: dataObj },
                  // ]);

                  this.updateLocalDataSet("insert", dataObj);

                  // dataGrid.refresh(true);
                }, 10);
              }
            },
          },
          setCellValue: (newData, value) => {
            newData.ProductCode = value;

            var index = this.productDataSourceItems.findIndex(
              (x) => x.ItemCode == value
            );
            if (index == -1) {
              this.displayValidationErrors([
                "This Product does not exist. Please try again",
              ]);
            } else {
              var productItem = this.productDataSourceItems[index];
              newData.ProductDescription = productItem.Description1;

              newData.ProductDescription = productItem.Description1;
              newData.SalesUM = productItem.SalesUM;
              newData.ItemCode = productItem.ItemCode;
              newData.Code = productItem.ItemCode;
              newData.ItemType = productItem.ItemType;
              newData.validCode = productItem.ItemCode;
              newData.IsNewLine = false;
            }
          },
          // renderAsync: true,
        },
        {
          caption: "Description",
          dataField: "ProductDescription",
          allowEditing: false,
          // renderAsync: true,
        },
        {
          caption: "Sales UM",
          dataField: "SalesUM",
          allowEditing: false,
          // renderAsync: true,
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode != "review",
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: async (e) => {
              if (e.event.key == "Enter") {
                var dataGrid = this.$refs["dx-data-grid-comp"].instance;
                if (
                  !this.productEntryLocalItems._array[
                    this.productEntryLocalItems._array.length - 1
                  ].ProductCode
                ) {
                  setTimeout(() => {
                    var rowIndex = dataGrid.getRowIndexByKey(
                      this.productEntryLocalItems._array[
                        this.productEntryLocalItems._array.length - 1
                      ].ID
                    );

                    var cellElement = dataGrid.getCellElement(
                      rowIndex,
                      "ProductCode"
                    );
                    dataGrid.focus(cellElement);
                    dataGrid.editCell(rowIndex, "ProductCode");
                  }, 100);
                } else {
                  var maxID = Math.max(
                    ...this.productEntryLocalItems._array.map((e) => e.ID)
                  );
                  let dataObj = Object.assign(
                    { IsCopyLine: false, IsNewLine: true },
                    productEntryBase
                  );
                  dataObj.ID = ++maxID;

                  // this.productEntryLocalItems.push([
                  //   { type: "insert", data: dataObj },
                  // ]);

                  this.updateLocalDataSet("insert", dataObj);

                  // dataGrid.refresh(true);
                }
              }
            },
            onValueChanged: this.onSalesUMQtyValueChanged,
            step: 0,
          },
          // setCellValue: async (newData, value, currentRowData) => {
          //   console.log(
          //     "newData, value, currentRowData",
          //     newData,
          //     value,
          //     currentRowData
          //   );
          //   newData.SalesUMQty = value;
          //   newData.ID = currentRowData.ID;
          //   this.getItemPriceDetails(newData, { ...currentRowData });
          // },
        },
        {
          caption: "Price",
          dataField: "SalesUMFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
        },
        {
          caption: "Discount",
          dataField: "DiscPcnt",
          allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode != "review",
          cssClass: "edit-cell-numberbox-field",
          // renderAsync: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onValueChanged: this.onDiscPcntValueChanged,
            format: "##,###,###,###,##0.00 '%'",

            onKeyDown: async (e) => {
              if (e.event.key == "Enter") {
                var maxID = Math.max(
                  ...this.productEntryLocalItems._array.map((e) => e.ID)
                );
                let dataObj = Object.assign(
                  { IsCopyLine: false, IsNewLine: true },
                  productEntryBase
                );
                dataObj.ID = ++maxID;

                // this.productEntryLocalItems.push([
                //   { type: "insert", data: dataObj },
                // ]);
                this.updateLocalDataSet("insert", dataObj);
              }
            },
          },
        },
        {
          caption: "Net Price",
          dataField: "SalesUMNetFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
        },
        {
          caption: "Tax",
          dataField: "TaxFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
        },
        {
          caption: "Total",
          dataField: "TaxableFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
        },
      ];
    },
  },
  methods: {
    async updateLocalDataSet(type, dataObj) {
      if (type == "insert")
        this.productEntryLocalItems.push([{ type: "insert", data: dataObj }]);
      else if (type == "update")
        this.productEntryLocalItems.push([
          {
            type: "update",
            key: dataObj.ID,
            data: dataObj,
          },
        ]);

      // await this.setStockPrices(dataObj);
      // await this.setLineTotals(dataObj);

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      dataGrid.refresh(true);
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    toolBarFormContentReady(e) {
      if (e)
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm)
            headerToolBarForm.getEditor("CustomerCode").instance().focus();
        }, 500);
    },

    async getItemPriceDetails(newData, currentRowData) {
      return await SalesOrderV3Service.setSaleItemPrice(
        // Non Grid List
        newData,
        currentRowData,
        this.model.SalesOrderTypeCode,
        this.model.BranchCode,
        this.model.CustomerCode,
        this.model.ExchangeRate,
        this.model.DateIn,
        this.model.RequiredByDate,
        false

        // eslint-disable-next-line no-unused-vars
      ).then(async (res) => {
        // this.productEntryLocalItems.push([
        //   {
        //     type: "update",
        //     key: res.ID,
        //     data: res,
        //   },
        // ]);

        this.updateLocalDataSet("update", res);
      });
    },

    setSaleItemPriceAllLines() {
      if (this.productEntryLocalItems.length > 0) {
        var promises = [];
        for (var i = 0; i < this.productEntryLocalItems.length; i++) {
          var record = this.productEntryLocalItems[i];
          if (record.ItemCode)
            promises.push(
              SalesOrderV3Service.setSaleItemPrice(
                // REPRICE ALL
                record,
                this.model.SalesOrderTypeCode,
                this.model.BranchCode,
                this.model.CustomerCode,
                this.model.ExchangeRate,
                this.model.DateIn,
                new Date(this.model.RequiredByDate),
                false
              )
            );
        }

        Promise.all(promises).then(function () {
          // this.$logger.debug("All SO details line prices are set");
          // that.refreshView();
          // console.log(">>>> ", data);
        });
      }
    },

    triggerPriceChange(e) {
      // alert("Price Change Trigger logic");
      if (e.event) this.setSaleItemPriceAllLines();
    },

    async setDeliveryAddressDataSourceItems(customerCode, lineNo) {
      logDev("customerCode", customerCode);
      let deliveryAddresDs = CustomerDeliveryAddressService.dataSourceConfig(
        "api/CustomerDeliveryAddress",
        {
          select: [
            "CompanyName",
            "PhysicalAddressStreetLine1",
            "PhysicalAddressStreetLine2",
            "PhysicalAddressSuburb",
            "PhysicalAddressState",
            "PhysicalAddressPostcode",
            "PhysicalAddressCountry",
            "RecordId",
            "LineNo",
          ],
          key: "RecordId",
          filter: [
            ["Inactive", "=", "N"],
            "and",
            ["CustomerCode", "=", customerCode],
          ],
        }
      );

      let results = await deliveryAddresDs.load();

      let defaultLineNo = 1;
      if (lineNo) defaultLineNo = lineNo;
      let deliveryAddressLine1Record = results.find(
        (x) => x.LineNo == defaultLineNo
      );

      if (deliveryAddressLine1Record) {
        deliveryAddressDataSourceItems = results;
        if (this.DeliveryAddressCompanyNameEditor()) {
          this.DeliveryAddressCompanyNameEditor().beginUpdate();
          this.DeliveryAddressCompanyNameEditor().option(
            "items",
            deliveryAddressDataSourceItems
          );
          this.DeliveryAddressCompanyNameEditor().option(
            "value",
            deliveryAddressLine1Record.CompanyName
          );
          this.DeliveryAddressCompanyNameEditor().endUpdate();
        }

        if (!lineNo) {
          this.model.DeliveryAddressCompanyName =
            deliveryAddressLine1Record.CompanyName;

          this.model.DeliveryAddressCountry =
            deliveryAddressLine1Record.PhysicalAddressCountry;
          this.model.DeliveryAddressPostcode =
            deliveryAddressLine1Record.PhysicalAddressPostcode;
          this.model.DeliveryAddressState =
            deliveryAddressLine1Record.PhysicalAddressState;
          this.model.DeliveryAddressStreetLine1 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine1;
          this.model.DeliveryAddressStreetLine2 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine2;
          this.model.DeliveryAddressSuburb =
            deliveryAddressLine1Record.PhysicalAddressSuburb;
          this.model.CustomerDeliveryAddressLineNo =
            deliveryAddressLine1Record.LineNo;
        }
      }
    },

    // Start - Details Data Grid Functions
    onDiscPcntValueChanged(e, lineData) {
      lineData.data.DiscPcnt = e.value;
      lineData.data.IsNewLine = false;
      let record = lineData.data;

      record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        record.SalesUMFXPrice,
        record.DiscPcnt
      );
      this.setBaseCurrencyPriceFromFXPrice(record);
    },

    async setBaseCurrencyPriceFromFXPrice(record) {
      record.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        record.SalesUMFXPrice,
        this.model.ExchangeRate
      );

      record.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
        record.SalesUMStandardPrice,
        record.SalesUMPrice
      );

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      await this.setStockPrices(record);
      await this.setLineTotals(record);

      // this.productEntryLocalItems.push([
      //   {
      //     type: "update",
      //     key: record.ID,
      //     data: record,
      //   },
      // ]);

      this.updateLocalDataSet("update", record);
    },

    setStockPrices(record) {
      record.StockUMQty = calculateStockUMQty(
        record.SalesUMQty,
        record.SalesUMConversion
      );

      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMConversion
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMConversion
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMConversion
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMConversion
      );
    },
    setLineTotals(record) {
      // FX Totals
      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.NetFXLineTotal = calculateNetFXLineTotal(
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt
      );

      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal
      );
      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt
      );
      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal
      );

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        this.model.ExchangeRate
      );
      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        this.model.ExchangeRate
      );
      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        this.model.ExchangeRate
      );
      record.LineTotal = calculateLineTotal(
        record.FXLineTotal,
        this.model.ExchangeRate
      );
      // window.ViewModel.calculateComputedFields();
    },
    onSalesUMQtyValueChanged(e, lineData) {
      lineData.data.SalesUMQty = e.value;
      lineData.data.IsNewLine = false;

      this.getItemPriceDetails(lineData.data, { ...lineData.data });
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onValueChanged) {
        let func = e.editorOptions.onValueChanged;
        e.editorOptions.onValueChanged = (event) => {
          func(event, {
            column: {
              dataField: e.dataField,
            },
            data: e.row.data,
            rowIndex: e.row.rowIndex,
          });
        };
      }
    },
    onRowPrepared(e) {
      if (e.rowType == "data") {
        if (e.data.IsNewLine) {
          e.data.IsNewLine = false;
          var dataGrid = e.component;

          setTimeout(() => {
            var cellElement = dataGrid.getCellElement(
              e.rowIndex,
              "ProductCode"
            );
            dataGrid.focus(cellElement);
            dataGrid.editCell(e.rowIndex, "ProductCode");
            dataGrid.navigateToRow(e.data.ID);
          }, 100);
        }
      }
    },
    async setProductDataSourceItems() {
      this.setLoading = true;
      let productsDS = ProductService.dataSourceConfig(
        "api/ProductFilterGroupSaleItemCompanyBranch",
        {
          filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
          sort: [{ selector: "Description1", asc: true }],
          preventPagination: true,
          select: [
            "ItemCode",
            "Description1",
            "BranchCode",
            "CustomerCode",
            "Inactive",
            "ItemType",
            "SalesUM",
            "StockUM",
          ],
        }
      );

      this.productDataSourceItems = await productsDS.load();

      this.setLoading = false;
    },
    // End - Details Data Grid Functions

    // Start - Header Form Functions
    HeaderFormInstance() {
      if (this.loaded)
        return this.$refs["gc-header-form-component"].$refs["gc-header-form"]
          .$refs["gc-form-comp"].instance;
    },
    DeliveryAddressCompanyNameEditor() {
      if (this.loaded) {
        return this.HeaderFormInstance().getEditor(
          "DeliveryAddressCompanyName"
        );
      }
    },
    ExchangeRateEditor() {
      return this.HeaderFormInstance().getEditor("ExchangeRate");
    },

    async onCustomerCodeValueChanged(e) {
      if (!e.value) this.model.CustomStatus = null;

      if (!e.value && e.event) {
        this.model.DeliveryAddressCompanyName = "";
        this.model.DeliveryAddressCountry = "";
        this.model.DeliveryAddressPostcode = "";
        this.model.DeliveryAddressState = "";
        this.model.DeliveryAddressStreetLine1 = "";
        this.model.DeliveryAddressStreetLine2 = "";
        this.model.DeliveryAddressSuburb = "";
        this.DeliveryAddressCompanyNameEditor().option("dataSource", []);
        return;
      }

      if (!e.event && e.value) {
        this.setDeliveryAddressDataSourceItems(e.value);
      }

      this.triggerPriceChange(e);
    },

    async onCustomerCodeItemClicked(e) {
      if (e.itemData.StopCredit == "Y") this.model.CustomStatus = "Credit Hold";
      else this.model.CustomStatus = undefined;

      let customerRecord = e.itemData;
      if (!customerRecord) {
        return;
      }

      this.model.CustomerCode = customerRecord.Code;
      this.model.CurrencyCode = customerRecord.CurrencyCode;
      await this.setProductDataSourceItems();

      this.setExchangeRateProperties();
      this.setDeliveryAddressDataSourceItems(this.model.CustomerCode);
    },

    async setExchangeRateProperties() {
      let isEditable = false;

      if (
        !(
          this.baseView.mode == "review" ||
          this.factor368ExchangeRateFieldEditable == "N"
        )
      ) {
        isEditable = this.model.CompanyCurrency != this.model.CurrencyCode;
      }

      if (this.ExchangeRateEditor())
        this.ExchangeRateEditor().option("readOnly", !isEditable);

      if (this.model.CompanyCurrency != this.model.CurrencyCode) {
        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;
      } else {
        this.model.ExchangeRate = 1;
      }
    },

    async onExchangeValueChanged(e) {
      if (!e.event) return;
      // if (this.isExchangeReverting) {
      //   this.isExchangeReverting = false;
      //   return;
      // }
      // if (e.value === 0) {
      //   this.displayValidationSummary([
      //     "Exchange rate should be greater than 0.0000",
      //   ]);
      //   this.isExchangeReverting = true;
      //   this.model.ExchangeRate = e.previousValue;
      // } else {
      //   this.setCompanyCurrencyPriceAllLines();
    },

    async onDeliveryAddressChanged(e) {
      this.model.CustomerDeliveryAddressLineNo = e.itemData.LineNo;
    },

    async onOrderNoChanged(e) {
      if (!e.event) return;
    },
    async onShipDateValueChanged(e) {
      if (!e.event) return;
    },
    async onRequiredByDateValueChanged(e) {
      if (!e.event) return;
      let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

      if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
        this.model.ShipDate = e.value;
      }
      if (getFactorByCode(616).Factorc != "Date In") {
        this.triggerPriceChange(e);
      }
    },
    async onDateInValueChanged(e) {
      if (!e.event) return;
      if (e.event && getFactorByCode(616).Factorc == "Date In") {
        this.triggerPriceChange(e);
      }
    },
    // End - Header Form Functions

    // Start - On initialized Functions
    async initialized() {
      if (this.baseView.mode == "create") {
        for (let index = 0; index < 1; index++) {
          let dataObj = Object.assign(
            { IsCopyLine: false, IsNewLine: true },
            productEntryBase
          );

          dataObj.ID = index + 1;

          this.productEntryLocalItems.push([{ type: "insert", data: dataObj }]);
        }

        // Factors from SO-v1
        // await this.$store.dispatch(
        //   "screenFactors/getFactors",
        //   [616, 549, 550, 505, 95, 87, 565, 571, 655, 643, 368, 639, 578]
        // );

        await this.$store.dispatch(
          "screenFactors/getFactors",
          [616, 549, 550, 95, 87, 565, 368, 18, 65, 66]
        );

        await this.setDefaultSalesRep();

        this.factor368ExchangeRateFieldEditable = getFactorByCode(368);

        //  Populate defaults in the Create Mode
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        this.model.CompanyCode = getFactorByCode(18).Factorc;
        this.model.BranchCode = getFactorByCode(65).Factorc;
        this.model.DivisionCode = getFactorByCode(66).Factorc;

        let response = undefined;
        if (
          !this.model.CompanyCode ||
          !this.model.BranchCode ||
          !this.model.DivisionCode
        ) {
          response = await DefaultCompanyBranchDivisionService.getDefault();

          if (response.data.value.length > 0) {
            this.model.CompanyCode = response.data.value[0].CompanyCode;
            this.model.BranchCode = response.data.value[0].BranchCode;
            this.model.DivisionCode = response.data.value[0].DivisionCode;
          }
        }

        this.getSalesUMs(this.model.BranchCode);

        await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
          (res) => {
            this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
          }
        );

        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;

        let factor549DefaultRequiredBy = getFactorByCode(549);

        if (factor549DefaultRequiredBy.Factorc == "Y") {
          let factor550RequiredByLeadDays = getFactorByCode(550);
          let requiredByLeadDays = parseInt(
            factor550RequiredByLeadDays.Factorc
          );
          let requiredByDate = new Date();
          requiredByDate.setDate(requiredByDate.getDate() + requiredByLeadDays);

          this.model.RequiredByDate = requiredByDate;

          let factor616DateForPriceGroupPriceSelection = getFactorByCode(616);
          if (factor616DateForPriceGroupPriceSelection.Factorc != "Date In") {
            this.model.FilterDate = this.model.RequiredByDate.toYYYYMMDD();
          } else {
            this.model.FilterDate = this.model.DateIn.toYYYYMMDD();
          }

          let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

          if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
            this.model.ShipDate = this.model.RequiredByDate;
          } else {
            this.model.ShipDate = new Date();
          }
        }

        let factor87DefaultSalesOrderTypeCode = getFactorByCode(87);
        this.model.SalesOrderTypeCode =
          factor87DefaultSalesOrderTypeCode.Factorc;

        this.loaded = true;
        this.showLoading(false);
      } else {
        // if (this.baseView.mode == "review")
        //   this.$store.dispatch("dataContext/setDataViewType", "review");
        // else
        //   this.$store.dispatch("dataContext/setDataViewType", "product-entry");

        await SalesOrderService.getByCode(this.baseView.id)
          .then((res) => {
            if (res.data.value[0].Customer.StopCredit == "Y")
              res.data.value[0].CustomStatus = "Credit Hold";
            else res.data.value[0].CustomStatus = undefined;

            this.model = res.data.value[0];
            this.model.CustomerDeliveryAddressLineNo =
              this.model.CustomerDeliveryAddressLineNo.split(" ")[0];

            this.model.CustomerName = res.data.value[0].Customer.Name;

            this.setDeliveryAddressDataSourceItems(
              this.model.CustomerCode,
              this.model.CustomerDeliveryAddressLineNo
            );
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });

        await SalesOrderNoteService.getNotesBySOCode(this.baseView.id)
          .then((res) => {
            this.model.Notes = res.data.value;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });

        await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
          (res) => {
            this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
          }
        );

        let record = await SalesOrderV3Service.getSalesOrderDetailsByCode(
          this.baseView.id
        );
        if (record && record.data.value.length > 0) {
          var data = record.data.value;
          await data.forEach(async (element, index) => {
            // this.model.Status = element.Status;
            // element.Description1 = element.ItemDescription;
            element.ItemDescription = element.Description1;
            element.Code = element.ItemCode;
            element.ProductCode = element.ItemCode;
            element.ProductDescription = element.Description1;
            element.ID = index + 1;
            element.validCode = element.ItemCode;
            // this.productEntryLocalItems.push({ ...element });

            this.productEntryLocalItems.push([
              { type: "insert", data: element },
            ]);
          });
        }

        await this.setProductDataSourceItems();

        this.loaded = true;
        this.showLoading(false);
      }
      // this.loaded = true;

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh(true);
    },

    async getSalesUMs(branchCode) {
      await SalesOrderV3Service.getSaleItemCompanyBranchProduct(
        branchCode
      ).then((res) => {
        this.salesUMsLocalData = res.data.value;
      });
    },

    async setDefaultSalesRep() {
      var featureItems = FeatureStorage.getItems();
      if (featureItems[0].ApplicationUserTypeCode == "Sales") {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
          (res) => {
            this.model.SalesRepresentativeCode =
              res.data.value[0].SalesRepresentativeCode;
          }
        );
      } else {
        if (getFactorByCode(95).Factorc) {
          this.model.SalesRepresentativeCode = getFactorByCode(95).Factorc;
        } else {
          await CustomerService.getByCode(this.baseView.id)
            .then((res) => {
              this.model.SalesRepresentativeCode =
                res.data.value[0].SalesRepresentativeCode;
            })
            .catch((err) => {
              if (err) {
                this.model.SalesRepresentativeCode = undefined;
              }
            });
        }
      }
    },
    // End - On initialized Functions

    // Save Sales Order
    async saveTransaction(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.saveSalesOrder(this.model);
      }
    },
    async saveSalesOrder(e) {
      if (this.productEntryLocalItems.length == 0) {
        // this.addValidations(
        //   "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again."
        // );

        this.displayValidationErrors([
          "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again.",
        ]);
        return;
      }

      if (e.NextStatus == "X") {
        let confirmLeaving = await this.$confirm(
          "Do you really wish to cancel sales order?",
          "Cancel sales order"
        );

        if (confirmLeaving) {
          this.$logger.trackEventButtonClick("Cancel Sales Order");
          this.cancelSalesOrder();
        }
      } else {
        let payload = this.getSavePayload();

        this.showLoading(true);
        await SalesOrderV3Service.saveSalesOrder(payload, payload.Code)
          .then((res) => {
            this.showLoading(false);

            if (this.baseView.mode == "create") {
              this.model.Code = res.data.Code;
            }

            this.$notify(
              `Sales Order ${this.model.Code} Successfully Saved`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/sales-order`,
            });
          })
          .catch((error) => {
            this.showLoading(false);

            this.displayServerError(error, "Save Sales Order Failed");
          });
      }
    },
    async cancelSalesOrder() {
      this.setLoading = true;
      var payload = {
        Code: this.baseView.id,
      };
      await SalesOrderService.cancelSalesOrder(payload)
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.setLoading = false;
          // this.$logger.debug("result ", result);
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-order`,
          });
        })
        .catch((error) => {
          this.setLoading = false;

          this.setLoading = false;
          this.displayServerError(error, "Cancel sales order Failed");
        });
    },

    getSavePayload() {
      var ExTaxTotal = 0;
      var TaxTotal = 0;
      var Total = 0;
      this.productEntryLocalItems._array.forEach((element) => {
        if (element.ItemCode && element.SalesUMQty) {
          ExTaxTotal = ExTaxTotal + element.TaxableFXLineTotal;
          TaxTotal = TaxTotal + element.TaxFXLineTotal;
          Total = Total + element.FXLineTotal;
        }
      });
      let payload = {
        BranchCode: this.model.BranchCode,
        Code: this.baseView.id ? parseInt(this.baseView.id) : 0,
        CompanyCode: this.model.CompanyCode,
        ConsignmentNo: this.model.ConsignmentNo,
        CurrencyCode: this.model.CurrencyCode,
        CustomerCode: this.model.CustomerCode,
        CustomerDeliveryAddressLineNo:
          this.model.CustomerDeliveryAddressLineNo.toString(),
        DateIn: new Date(this.model.DateIn).toSaveDate(),
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        Status: this.model.NextStatus,
        DivisionCode: this.model.DivisionCode,
        ExchangeRate: this.model.ExchangeRate,
        ExTaxTotal: parseFloat(ExTaxTotal.toFixed(2)),
        ItemCount: this.getSalesOrderDetailPayload().length,
        OrderNo: "",
        RequiredByDate: new Date(this.model.RequiredByDate).toSaveDate(),
        SalesOrderTypeCode: this.model.SalesOrderTypeCode,
        SalesRepresentativeCode: this.model.SalesRepresentativeCode,
        ShipDate: new Date(this.model.ShipDate).toSaveDate(),
        // Status: "A",
        TaxTotal: parseFloat(TaxTotal.toFixed(2)),
        Total: parseFloat(Total.toFixed(2)),
        UserComment1: this.model.UserComment1,
        UserComment2: this.model.UserComment2,
        UserComment3: this.model.UserComment3,
        UserComment4: this.model.UserComment4,
        UserComment5: this.model.UserComment5,
        UserComment6: this.model.UserComment6,
        UserComment7: this.model.UserComment7,
        UserComment8: this.model.UserComment8,
        UserComment9: this.model.UserComment9,
        UserComment10: this.model.UserComment10,
        UserComment11: this.model.UserComment11,
        UserComment12: this.model.UserComment12,
        UserComment13: this.model.UserComment13,
        UserComment14: this.model.UserComment14,
        UserComment15: this.model.UserComment15,
        UserComment16: this.model.UserComment16,
        UserComment17: this.model.UserComment17,
        UserComment18: this.model.UserComment18,
        UserComment19: this.model.UserComment19,
        UserComment20: this.model.UserComment20,

        SalesOrderDetails: this.getSalesOrderDetailPayload(),
        SalesOrderNotes: [],
      };

      if (this.model.Notes && this.model.Notes.length > 0) {
        let notes = this.model.Notes.map((note) => {
          let n = {
            LineNo: note.LineNo ? note.LineNo : 0,
            Note: note.Note,
          };
          return n;
        });
        payload.SalesOrderNotes = notes;
      }

      // delete payload.Status;
      // if (this.baseView.mode == "create") delete payload.Code;

      if (this.baseView.mode != "create") {
        payload.DateChanged = this.model.DateChanged;
      }
      return payload;
    },

    getSalesOrderDetailPayload() {
      let details = [];

      this.productEntryLocalItems._array.forEach((data) => {
        let detailObj = {
          SalesOrderCode: data.SalesOrderCode ? data.SalesOrderCode : 0,
          LineNo: data.LineNo ? data.LineNo : 0,
          ItemCode: data.ItemCode,
          SalesUM: data.SalesUM,
          SalesUMQty: data.SalesUMQty,
          DiscPcnt: data.DiscPcnt,
          SalesUMPrice: data.SalesUMPrice,
          Comment: data.Comment,
          RecordId: "00000000-0000-0000-0000-000000000000",
        };

        if (data.ItemCode && data.SalesUMQty) details.push(detailObj);
      });

      return details;
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.sales-order-v2 {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
}
</style>
